import { render, staticRenderFns } from "./MembershipRateEdit.vue?vue&type=template&id=19968fe3&scoped=true&"
import script from "./MembershipRateEdit.vue?vue&type=script&lang=js&"
export * from "./MembershipRateEdit.vue?vue&type=script&lang=js&"
import style0 from "./MembershipRateEdit.vue?vue&type=style&index=0&id=19968fe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19968fe3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VApp,VCol,VSpacer,VSwitch})
